import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { ILinkAStyledComponent } from './linkA.models';
import { cssprops } from '@vfit/shared/themes';

import * as S from '../../link.style';

const _disabled = css`
  &,
  &:hover,
  &:active {
    ${S.disabled}
  }
`;

export const A = styled.a<ILinkAStyledComponent>`
  ${({ variant }) => (variant === 'regular' ? '' : 'text-decoration: none;')}
  ${S.common}
  ${({ disabled }) => (disabled ? _disabled : '')}
  ${cssprops.styled as any}
`;